/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { createDefaultRunStore, createDefaultDataStore, } from "../data/index.js";
import { GraphStore, makeTerribleOptions } from "./graph-store.js";
import { Graph } from "./graph/graph.js";
import { MutableGraphImpl } from "./graph/mutable-graph.js";
import { RunObserver } from "./run/run.js";
/**
 *
 * @deprecated Use GraphStore instead.
 */
export const inspect = (graph, options = {}) => {
    const store = new GraphStore(makeTerribleOptions(options));
    return new Graph("", new MutableGraphImpl(graph, store));
};
export const createRunObserver = (store, options) => {
    return new RunObserver(store, options || {});
};
export { Run } from "./run/run.js";
export function createGraphStore(args) {
    return new GraphStore(args);
}
//# sourceMappingURL=index.js.map